export const FILE_EXPORT_TYPE = {
  CSV: "csv",
  PDF: "pdf",
  XLSX: "XLSX",
  SPED: "sped",
};

export const FILE_EXPORT_LIST = [
  { type: FILE_EXPORT_TYPE.CSV, label: "CSV" },
  { type: FILE_EXPORT_TYPE.PDF, label: "PDF" },
  { type: FILE_EXPORT_TYPE.XLSX, label: "XLSX" },
  { type: FILE_EXPORT_TYPE.SPED, label: "SPED" },
];
